const _imgCache = {};
window.QuoterPreview = {
  init(p, l = {}) {
    if (!p || !p.getContext)
      return (console.error("Canvas no v\xE1lido"), null);
    const b = p.getContext("2d");
    return {
      canvas: p,
      ctx: b,
      w: p.width,
      h: p.height,
      options: {
        showGrid: l.showGrid ?? !0,
        backgroundColor: l.backgroundColor || "#f5f5f5",
        gridColor: l.gridColor || "rgba(0, 0, 0, 0.1)",
        stickerColor: l.stickerColor || "#ffffff",
        borderColor: l.borderColor || "#e0e0e0",
        compareObjects: l.compareObjects ?? !0,
        laptopImageUrl: l.laptopImageUrl || window.QUOTER_LAPTOP_IMAGE || null,
        ...l,
      },
      referenceObjects: {
        tarjeta: {
          width: 8.5,
          height: 5.5,
          label: "Tarjeta de cr\xE9dito",
          icon: "\u{1F4B3}",
        },
        celular: { width: 7, height: 14, label: "iPhone", icon: "\u{1F4F1}" },
        mano: { width: 8, height: 18, label: "Mano promedio", icon: "\u270B" },
      },
      laptopDimensions: {
        width: 34.93,
        height: 23.29,
        screenWidth: 32,
        screenHeight: 20,
        screenOffsetX: 1.5,
        screenOffsetY: 1.6,
      },
      laptopImage: null,
      laptopImageLoaded: !1,
      render(t, s, e = null) {
        (this.clear(),
          this.drawBackground(),
          this.options.compareObjects
            ? this.renderComparisonMode(t, s, e)
            : this.options.showGrid
              ? this.renderGridMode(t, s, e)
              : this.renderSimpleMode(t, s, e));
      },
      renderGridMode(t, s, e) {
        const i = Math.min(this.w, this.h) * 0.7,
          o = this.calculateScale(t, s, i),
          h = t * o,
          r = s * o,
          c = (this.w - h) / 2,
          n = (this.h - r) / 2;
        (this.drawGrid(o),
          this.drawSticker(c, n, h, r, e),
          this.drawDimensions(c, n, h, r, t, s));
      },
      renderSimpleMode(t, s, e) {
        const i = Math.min(this.w, this.h) * 0.7,
          o = this.calculateScale(t, s, i),
          h = t * o,
          r = s * o,
          c = (this.w - h) / 2,
          n = (this.h - r) / 2;
        (this.drawSticker(c, n, h, r, e),
          this.drawDimensions(c, n, h, r, t, s));
      },
      renderComparisonMode(t, s, e) {
        if (!this.laptopImageLoaded) {
          this.loadLaptopImage(() => {
            this.renderComparisonMode(t, s, e);
          });
          return;
        }
        const i = Math.min(this.w, this.h) * 0.75,
          o = Math.min(
            i / this.laptopDimensions.width,
            i / this.laptopDimensions.height,
            (this.w - 100) / t,
            (this.h - 100) / s,
          ),
          h = this.laptopDimensions.width * o,
          r = this.laptopDimensions.height * o,
          m = t * o,
          w = s * o,
          c = m > h || w > r ? 30 : (this.w - h) / 2,
          n = m > h || w > r ? 30 : (this.h - r) / 2;
        this.drawLaptop(c, n, h, r);
        const a = c + this.laptopDimensions.screenOffsetX * o,
          d = n + this.laptopDimensions.screenOffsetY * o,
          g = a + 20,
          u = d + 20;
        (this.drawSticker(g, u, m, w, e),
          this.drawDimensions(g, u, m, w, t, s));
      },
      calculateScale(t, s, e) {
        const i = Math.max(t, s);
        return e / i;
      },
      clear() {
        this.ctx.clearRect(0, 0, this.w, this.h);
      },
      drawBackground() {
        ((this.ctx.fillStyle = this.options.backgroundColor),
          this.ctx.fillRect(0, 0, this.w, this.h));
      },
      drawGrid(t) {
        ((this.ctx.strokeStyle = this.options.gridColor),
          (this.ctx.lineWidth = 1));
        const s = t;
        for (let e = 0; e < this.w; e += s)
          (this.ctx.beginPath(),
            this.ctx.moveTo(e, 0),
            this.ctx.lineTo(e, this.h),
            this.ctx.stroke());
        for (let e = 0; e < this.h; e += s)
          (this.ctx.beginPath(),
            this.ctx.moveTo(0, e),
            this.ctx.lineTo(this.w, e),
            this.ctx.stroke());
      },
      drawReferenceObject(t, s, e) {
        let i = null;
        const o = s * e;
        o < 50
          ? (i = this.referenceObjects.tarjeta)
          : o < 150
            ? (i = this.referenceObjects.celular)
            : (i = this.referenceObjects.mano);
        const h = i.width * t,
          r = i.height * t,
          c = 30,
          n = this.h - r - 30;
        ((this.ctx.strokeStyle = "rgba(0, 0, 0, 0.3)"),
          (this.ctx.lineWidth = 2),
          this.ctx.setLineDash([5, 5]),
          this.ctx.strokeRect(c, n, h, r),
          this.ctx.setLineDash([]),
          (this.ctx.fillStyle = "rgba(255, 255, 255, 0.9)"),
          this.ctx.fillRect(c, n - 30, h, 25),
          (this.ctx.fillStyle = "#666"),
          (this.ctx.font = "12px system-ui, -apple-system, sans-serif"),
          (this.ctx.textAlign = "center"),
          this.ctx.fillText(`${i.icon} ${i.label}`, c + h / 2, n - 12));
      },
      loadLaptopImage(t) {
        if (this.laptopImage) {
          t();
          return;
        }
        const s = new Image();
        ((s.crossOrigin = "anonymous"),
          (s.onload = () => {
            ((this.laptopImage = s), (this.laptopImageLoaded = !0), t && t());
          }),
          (s.onerror = () => {
            (console.error("Error al cargar imagen de laptop, usando fallback"),
              (this.laptopImageLoaded = !0),
              t && t());
          }),
          (s.src = this.options.laptopImageUrl));
      },
      drawLaptop(t, s, e, i) {
        if (this.laptopImage)
          (this.ctx.save(),
            (this.ctx.shadowColor = "rgba(0, 0, 0, 0.15)"),
            (this.ctx.shadowBlur = 40),
            (this.ctx.shadowOffsetX = 0),
            (this.ctx.shadowOffsetY = 20),
            this.ctx.drawImage(this.laptopImage, t, s, e, i),
            this.ctx.restore());
        else {
          (this.ctx.save(),
            (this.ctx.shadowColor = "rgba(0, 0, 0, 0.2)"),
            (this.ctx.shadowBlur = 30),
            (this.ctx.shadowOffsetX = 0),
            (this.ctx.shadowOffsetY = 15),
            (this.ctx.fillStyle = "#b0b0b0"),
            this.ctx.fillRect(t, s, e, i));
          const o =
              t +
              (this.laptopDimensions.screenOffsetX /
                this.laptopDimensions.width) *
                e,
            h =
              s +
              (this.laptopDimensions.screenOffsetY /
                this.laptopDimensions.height) *
                i,
            r =
              (this.laptopDimensions.screenWidth /
                this.laptopDimensions.width) *
              e,
            c =
              (this.laptopDimensions.screenHeight /
                this.laptopDimensions.height) *
              i;
          ((this.ctx.fillStyle = "#2c2c2c"),
            this.ctx.fillRect(o, h, r, c),
            this.ctx.restore(),
            (this.ctx.fillStyle = "#666"),
            (this.ctx.font = "bold 14px system-ui, -apple-system, sans-serif"),
            (this.ctx.textAlign = "center"),
            this.ctx.fillText("Laptop", t + e / 2, s + i + 20));
        }
      },
      drawSticker(t, s, e, i, o) {
        ((this.ctx.shadowColor = "rgba(0, 0, 0, 0.15)"),
          (this.ctx.shadowBlur = 20),
          (this.ctx.shadowOffsetX = 0),
          (this.ctx.shadowOffsetY = 10),
          (this.ctx.fillStyle = this.options.stickerColor),
          this.ctx.fillRect(t, s, e, i),
          (this.ctx.shadowColor = "transparent"),
          (this.ctx.shadowBlur = 0),
          (this.ctx.shadowOffsetX = 0),
          (this.ctx.shadowOffsetY = 0),
          o ? this.drawImage(t, s, e, i, o) : this.drawPlaceholder(t, s, e, i),
          (this.ctx.strokeStyle = this.options.borderColor),
          (this.ctx.lineWidth = 2),
          this.ctx.strokeRect(t, s, e, i));
      },
      drawImage(t, s, e, i, o) {
        const _draw = (h) => {
          (this.ctx.save(),
            (this.ctx.imageSmoothingEnabled = !0),
            (this.ctx.imageSmoothingQuality = "high"));
          const r = h.width / h.height,
            c = e / i;
          let n = e,
            a = i,
            d = t,
            x = s;
          (r > c
            ? ((a = e / r), (x = s + (i - a) / 2))
            : ((n = i * r), (d = t + (e - n) / 2)),
            this.ctx.drawImage(h, d, x, n, a),
            this.ctx.restore());
        };
        if (_imgCache[o]) {
          _draw(_imgCache[o]);
          return;
        }
        const h = new Image();
        ((h.crossOrigin = "anonymous"),
          (h.onload = () => {
            ((_imgCache[o] = h), _draw(h));
          }),
          (h.onerror = () => {
            (console.error("Error al cargar imagen para preview"),
              this.drawPlaceholder(t, s, e, i));
          }),
          (h.src = o));
      },
      drawPlaceholder(t, s, e, i) {
        const o = t + e / 2,
          h = s + i / 2;
        ((this.ctx.fillStyle = "#ccc"),
          (this.ctx.font = `${Math.min(e, i) * 0.3}px system-ui`),
          (this.ctx.textAlign = "center"),
          (this.ctx.textBaseline = "middle"),
          this.ctx.fillText("\u{1F5BC}\uFE0F", o, h - 20),
          (this.ctx.font = "14px system-ui, -apple-system, sans-serif"),
          (this.ctx.fillStyle = "#999"),
          this.ctx.fillText("Tu dise\xF1o aqu\xED", o, h + 20));
      },
      drawDimensions(t, s, e, i, o, h) {
        ((this.ctx.shadowColor = "rgba(0, 0, 0, 0.2)"),
          (this.ctx.shadowBlur = 8),
          (this.ctx.shadowOffsetX = 0),
          (this.ctx.shadowOffsetY = 2),
          (this.ctx.fillStyle = "rgba(255, 255, 255, 0.98)"),
          (this.ctx.strokeStyle = "#2563EB"),
          (this.ctx.lineWidth = 2));
        const r = 32,
          c = 90,
          n = Math.max(2, Math.min(t + (e - c) / 2, this.w - c - 2)),
          a = Math.max(2, s - r - 10);
        (this.ctx.fillRect(n, a, c, r),
          this.ctx.strokeRect(n, a, c, r),
          (this.ctx.shadowColor = "transparent"),
          (this.ctx.shadowBlur = 0),
          (this.ctx.fillStyle = "#1F2937"),
          (this.ctx.font = "bold 14px system-ui, -apple-system, sans-serif"),
          (this.ctx.textAlign = "center"),
          (this.ctx.textBaseline = "middle"),
          this.ctx.fillText(`${o} cm`, n + c / 2, a + r / 2),
          (this.ctx.shadowColor = "rgba(0, 0, 0, 0.2)"),
          (this.ctx.shadowBlur = 8),
          (this.ctx.shadowOffsetX = 0),
          (this.ctx.shadowOffsetY = 2));
        const d = 90,
          x = Math.min(t + e + 10, this.w - d - 2),
          f = Math.max(2, Math.min(s + (i - r) / 2, this.h - r - 2));
        ((this.ctx.fillStyle = "rgba(255, 255, 255, 0.98)"),
          this.ctx.fillRect(x, f, d, r),
          this.ctx.strokeRect(x, f, d, r),
          (this.ctx.shadowColor = "transparent"),
          (this.ctx.shadowBlur = 0),
          (this.ctx.fillStyle = "#1F2937"),
          this.ctx.fillText(`${h} cm`, x + d / 2, f + r / 2));
      },
      setOption(t, s) {
        this.options[t] = s;
      },
      resize(t, s) {
        const e = window.devicePixelRatio || 1;
        ((this.w = t),
          (this.h = s),
          (this.canvas.width = t * e),
          (this.canvas.height = s * e),
          this.ctx.scale(e, e));
      },
    };
  },
};
